export default __webpack_public_path__ + "static/media/green.3f5bb67f.svg";